import {h, Fragment} from "preact"
import { useAppState, InfiniteScroll } from "@nosto/preact"
import { useEffect } from 'preact/hooks'

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import Loader from "./elements/Loader"
import useSwatches from './useSwatches'

export default function Serp() {
    const {
        response: { products },
        loading, query, response
    } = useAppState()
    const foundProducts = products && products.total > 0;
    const docCount = response.products?.total ?? 0

    const { swatchData } = useSwatches();

    useEffect(() =>{
        $("head title").text(`Search: ${docCount} results found for "${query.query}"`);
    },[products])
        

    return (
        <>
            {foundProducts && (
            <header class="ns-header PageHeader">
                <div class="ns-container Container">
                    <div class="SectionHeader SectionHeader--center">
                        <h1 class="SectionHeader__Heading Heading u-h1">{docCount} results for "{query.query}"</h1>
                        {/* <div id="bc-sf-product-count" class="SectionHeader__Description">{docCount} results for "{query.query}"</div> */}
                    </div>
                </div>
            </header>
            )}
            <div class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-w-100" data-nosto-element="search">
                {foundProducts && (
                    <>
                        <Sidebar />
                        <Toolbar mobile />
                    </>
                )}

                <div class="ns-collection-inner-products ns-d-block ns-d-md-inline ns-w-100 ns-border-box">
                    {foundProducts ? (
                        <>
                            <InfiniteScroll>
                                <Products swatchData={swatchData}/>
                            </InfiniteScroll>
                        </>
                    ) : loading ? (
                        <Loader />
                    ) : (
                        <>
                        <header class="ns-header PageHeader">
                            <div class="ns-container Container">
                                <div class="SectionHeader SectionHeader--center">
                                    <h1 class="SectionHeader__Heading Heading u-h1">{docCount} results for "{query.query}"</h1>
                                    {/* <div id="bc-sf-product-count" class="SectionHeader__Description">{docCount} results for "{query.query}"</div> */}
                                </div>
                            </div>
                        </header>
                        <NoResults />
                        </>
                    )}
                </div>
            </div>
        </>
    )
}

